// Иконка бумажного самолётика — кнопка «Отправить».
import React from "react";

export function PaperAirplaneIcon({ size = 24, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke={color} strokeWidth="1.8"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 3 3 11l7 2 2 7 9-17Z" />
      <path d="M10 13l11-10" />
    </svg>
  );
}

export default PaperAirplaneIcon;
